/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-03-07 10:10:45
 */
export default{
    base:{
        search:'查询',
        add:'新增',
        edit:'编辑',
        save:'保存',
        delete:'删除',
        cancel:'取消',
        download:'下载',
        push:'推送',
        release:'发布',
        use:'启用',
        forbidden:'禁用',
        released:'已发布',
        invalid:'无效',
        test:'测试中',
        customCol:'自定义列',
        person:'个人中心',
        logout:'退出登录',
        login:'登录',
        logoutMsg:'确定退出当前登录？',
        tip:'温馨提示',
        confirm:'确定',
        cancel:'取消',
        cancelReplace:'取消更换',
        reset:'重置',
        yes:'是',
        no:'否',
        uploadFirmware:'上传固件',
        total:'共',
        page:'页',
        row:'条',
        upload:'上传',
        uploadPicture:'上传图片',
        enter:'请输入',
        select:'请选择',
        great:'伟大',
        homeTitle:'的艺术品不必追随潮流，它本身就能引领潮流',
        selectFile:'选择文件',
        selectDateRange:'请选择日期范围',
        noData:'暂无数据',
        dataView:"数据视图",
        downLoad:"下载",
        close:"关闭",
        refresh:'刷新',
        currentDate:'当前时间',
        week:'周',
        order_number:'序号',
        operate:'操作',
        customColumns:'自定义列显示',
        delMsg:'是否确认删除?',
        uploadImg:'上传图片',
        noEmpty:'不能为空!',
        needUploadImg:'请上传图片！',
        saveSuccessMsg:'保存成功！',
        addSuccessMsg:'新增成功！',
        editSuccessMsg:'编辑成功！',
        delSuccessMsg:'删除成功！',
        cancelSuccessMsg:'取消成功！',
        clearLocalStorage:'清除缓存',
        deleteConfirm:'是否确认删除？',
        hasEmptyItem:'存在为空的数据项，请填写后再提交！',
        more:'更多',
        pickDate:"请选择日期",
        summary:'全部汇总',
        weekSummary:'周汇总',
        normal:'正常',
        selectConfirmMsg:'是否确定所选项，点击确定将会保存该数据',
        noEmpty:'不能为空！',
        logoText:'服务工具管理后台',
        en:'英语',
        de:'德语',
        fr:'法语',
        exportData:'导出数据',
    },
    msg:{
        deleteMsg:'是否确认删除？',
        uploadMsg:'固件上传成功！',
        forbiddenMsg:'固件已禁用！',
        releaseMsg:'请选择发布环境！',
        limitMsg:'请选择发布限制！',
        limitValMsg:'请输入发布限制数值！',
        fileMsg:'请选择需上传固件！',
        cancelTip: '是否确认取消？',
        delMsg:'是否确认删除？',
    },
    menu:{
        Home:'首页',
        DataQuery:'数据查询',
        CyclingData:'骑行数据',
        BikeInfo:'车辆信息',
        AdvancedFunction:'高级功能',
        PermissionManagement:'权限管理',
        AccountManage:'账号管理',

        subHome:'数字化让您更加了解用户',
        subCyclingData:'用户骑行数据管理',
        subBikeInfo:'配置信息管理',
        subPermissionManagement:'数字化赋能，一切尽在掌握',
        subAccountManage:'管理员后台账号进行权限管理',
    },
    login:{
        desc:'在您访问HEPHA后台网站之前。',
        subDesc:'请登录您的帐户；否则，您将无法使用任何功能。',
        email_address:'邮箱',
        password:'密码',
        login:'登录',
        rememberPassword:'记住账号',
        forgotPassword:'忘记密码?',
        createAccount:'创建账号',
        createSubDesc:'请填写您的联系方式',
        adminEmail:"管理员邮箱",
        firstName:'名字',
        lastName:'姓',
        companyName:'公司名称',
        emailAddress:'邮箱地址',
        telephone:'电话',
        password:'密码',
        comfirmPassword:'确认密码',
        createAccountBtn:'创建账号',
        requestOnce:'您每分钟只能请求一次验证码',
        hephaAdminEmail:"HEPHA管理员电子邮件:",
        useAccountLogin:'使用您的账号登录',
        note:'注意:',
        msg1:'我们将首先向您发送一封确认电子邮件。确认电子邮件后，您的注册信息将记录在后台。',
        msg2:'管理员在后台激活后，您的帐户将成功注册。',
        msg3:'您需要先确认电子邮件，然后管理员需要在后台激活您的帐户。',
    },
    home:{
        morning:'早上好！',
        forenoon:'上午好！',
        noon:'中午好！',
        afternoon:'下午好！',
        evening:'晚上好！',
        welcome:'欢迎登录 HEPHA 生态平台',
    },
    FAQ:{
        help_title:'FAQ标题（英语）',
        help_title_de:'FAQ标题（德语）',
        help_title_fr:'FAQ标题（法语）',
        labels:'FAQ标签',
        item_name:'FAQ明细项（英语）',
        item_name_de:'FAQ明细项（德语）',
        item_name_fr:'FAQ明细项（法语）',
        AddFAQ:'新增FAQ',
        addItem:'新增明细项',
        editFAQ:'编辑FAQ',
    },
    video:{
        help_title:'视频标题（英语）',
        help_title_de:'视频标题（德语）',
        help_title_fr:'视频标题（法语）',
        help_url: '视频链接',
        labels:'视频标签',
        AddVideo:'新增Video',
        editVideo:'编辑Video',
    },
    part:{
        AddPart:'新增部件',
        editPart:'编辑部件',
        model_category:'型号分类',
        model_key:'总成位置',
        model_value:'型号名称',
        avatar_url:'部件图片',
        uploadTitle:'上传图片',
        motor:'电机',
        display:'仪表',
        battery:'电池',

        addFaultCode:'新增故障码',
        editFaultCode:'编辑故障码',
        
        fault_code:'故障码',
        fault_path:'URL',
        fault_status:'故障状态',
        fault_limit:'故障问题',
        fault_measure:'解决方案',
        fault_status_de:'故障状态（德语）',
        fault_limit_de:'故障问题（德语）',
        fault_measure_de:'解决方案（德语）',
        fault_status_fr:'故障状态（法语）',
        fault_limit_fr:'故障问题（法语）',
        fault_measure_fr:'解决方案（法语）',
    },
    account:{
        email:'邮箱',
        active:'确认激活',
        activeSuccessfully:'激活成功',
    },
    config:{
        label_name:'标签名称（英语）',
        label_name_de:'标签名称（德语）',
        label_name_fr:'标签名称（法语）',
        addLabel:'新增标签',
        editLabel:'编辑标签',
    }
}